import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { HiDevicePhoneMobile } from "react-icons/hi2";

function InstallPrompt() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Detect if app is already installed
        const isStandalone =
            window.matchMedia("(display-mode: standalone)").matches ||
            window.navigator.standalone === true;

        if (isStandalone) return;

        // Detect mobile
        const checkMobile = () => {
            const isTouch = window.matchMedia("(pointer: coarse)").matches;
            setIsMobile(isTouch && window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        // Listen for install prompt
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsVisible(true);
        };

        window.addEventListener("beforeinstallprompt", handler);
        window.addEventListener("appinstalled", () => {
            setIsVisible(false);
            setDeferredPrompt(null);
        });

        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const handleInstallClick = () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
                setDeferredPrompt(null);
                setIsVisible(false);
            }
        });
    };

    const handleDismiss = () => {
        setIsVisible(false);
    };

    if (!deferredPrompt || !isVisible || !isMobile) return null;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-md mx-4">
            <div className="bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl shadow-lg p-3">
                <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2 flex-1">
                        <div className="w-8 h-8 border-2 border-white rounded-lg flex items-center justify-center flex-shrink-0">
                            <HiDevicePhoneMobile className="text-base text-white" />
                        </div>
                        <div>
                            <p className="text-white font-semibold text-sm">Install Utsav Buy?</p>
                            <p className="text-white/90 text-xs">Get the best shopping experience</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-1.5">
                        <button
                            onClick={handleInstallClick}
                            className="bg-white text-orange-600 font-semibold text-xs px-3 py-1.5 rounded-lg hover:bg-orange-50 transition-colors"
                        >
                            Install
                        </button>
                        <button
                            onClick={handleDismiss}
                            className="w-6 h-6 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors text-white"
                            aria-label="Close"
                        >
                            <MdClose className="text-sm" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstallPrompt;
